export default __webpack_public_path__ + "static/media/icon-sensores.6abd5cc6.svg";